// extracted by mini-css-extract-plugin
module.exports = {"ticket":"Ticket_ticket__mNoik","ticket__polygon":"Ticket_ticket__polygon__31v8H","ticket__footer":"Ticket_ticket__footer__2PldD","ticket__money":"Ticket_ticket__money__1ggGY"};